import { Button, Grid, Menu, Layout, Paper, Table, ButtonGroup, Typography, Alert, Loader } from "../../components";
import useSWR from 'swr'
import API from "../../API";
import moment from "moment";
import { COMPANY_OPTIONS } from "../../constants";
import currency from 'currency.js'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useAPI, useAxios } from '../../hooks'
import { Chip } from "@mui/material";
import { Fragment, useContext } from "react";
import AuthContext from "../../context/auth";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import { getBidStatusColor, getBidStatusLabel } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material";


export function Bids () { 
    const theme = useTheme()
    const [bids, refetchBids] = useAxios('/bid')
    const [api, postAPI] = useAxios({
        method: 'POST'
    }, {
        manual: true
    })
    const { me } = useContext(AuthContext)
    
    const navigate = useNavigate()

    return (
        <Layout>
            <Grid container justifyContent="center" minHeight={"calc(100vh - 64px)"} padding={3} spacing={2}>
                {api.loading || bids.loading ? (
                    <div style={{
                        display: 'flex',
                        flex: '1',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Loader />
                    </div>
                ) : (<Fragment>
                <Grid item xs={12} sm={11}>
                    {
                        <Alert color="warning" icon={false}>
                            <strong>Você possui ofertas em emissão!</strong><br/>
                            Não se esqueça de finalizar a oferta quando não houverem mais emissões a serem feitas.
                        </Alert>
                    }
                </Grid>
                <Grid item xs={12} sm={11}>
                    <Paper elevation={1}>
                    <Table 
                        columns={[
                            { field: 'id', headerName: 'ID', width: 50 },
                            { field: 'created_at', headerName: 'Data', flex: 1, valueFormatter: ({value}) => {
                                return moment(value).format('DD/MM/YYYY HH:mm:ss')
                            } },
                            { field: 'user', headerName: 'Fornecedor', flex: 1 },
                            { field: 'company', headerName: 'Companhia', flex: 1 },
                            { field: 'amount', headerName: 'Quantidade', flex: 1, renderCell: ({row, value}) => {
                                return (
                                    <Fragment>
                                        <Typography variant="body2">
                                            {Number(value).toLocaleString('pt-BR')}
                                        </Typography>
                                        {!!row.used_miles && (<Typography variant="body2" fontWeight="bold" marginLeft="5px" color={theme.palette.error.main}>
                                            (-{Number(row.used_miles).toLocaleString('pt-BR')})
                                        </Typography>)}
                                    </Fragment>
                                )
                            }, valueGetter: ({ row }) => {
                                return currency(row.amount).subtract(row.used_miles).value
                            }},
                            { field: 'price_per_k', headerName: 'Valor do Milheiro', width: 130, valueFormatter: ({value}) => {
                                return currency(value).format({
                                    symbol: 'R$ ',
                                    decimal: ',',
                                    separator: '.'
                                })
                            }},
                            { field: 'pax', headerName: 'CPFs Disponíveis', flex: 1, renderCell: ({row, value}) => {
                                return (
                                    <Fragment>
                                        <Typography variant="body2">
                                            {value}
                                        </Typography>
                                        {!!row.used_pax && !!row.pax && (<Typography variant="body2" fontWeight="bold" marginLeft="5px" color={theme.palette.error.main}>
                                            (-{row.used_pax})
                                        </Typography>)}
                                    </Fragment>
                                )
                            },
                            valueGetter: ({value, row}) => {
                                return value ? currency(value).subtract(row.used_pax).value : '∞'
                            }},
                            {
                                field: 'status', headerName: 'Status', flex: 1, 
                                valueGetter: ({ value }) => {
                                    return getBidStatusLabel(value)
                                },
                                renderCell: ({ formattedValue, row }) => {
                                    return (
                                        <Chip color={getBidStatusColor(row.status)} label={formattedValue} />
                                    )
                                }
                            },
                            {
                                field: 'actions', headerName: '', flex: 1, align: 'right', sortable: false, filterable: false, disableColumnMenu: true, renderCell: ({row}) => {
                                    const messageText = encodeURI(`Olá, ${row.user}! Tudo bem? Me chamo ${me?.name} e estou entrando em contato para falar da sua oferta número ${row.id} na Next Pontos.`)

                                    const menuOptions = [
                                        { label: 'Ver Detalhes', onClick: async () => {
                                            navigate(`/ofertas/${row.id}`)
                                            }
                                        }
                                    ]

                                    if (row.status === 'PENDING' || row.status === 'DENIED') {
                                        menuOptions.push({ label: 'Aceitar', onClick: async () => {
                                            await postAPI({ url: `/bid/${row.id}/accept` })
                                            refetchBids()
                                            }
                                        })
                                    }

                                    if (row.status === 'PENDING' || row.status === 'ACCEPTED') {
                                        menuOptions.push({ label: 'Recusar', onClick: async () => {
                                            await postAPI({ url: `/bid/${row.id}/deny` })
                                            refetchBids()
                                            }
                                        })
                                    }

                                    if (row.status === 'AWAITING_ORDER' || row.status === 'ON_ORDER') {
                                        menuOptions.push({ 
                                            label: 'Emitir', 
                                            onClick: async () => {
                                                navigate(`/ofertas/${row.id}/emissao`)
                                            }
                                        })
                                    }

                                    if (row.status === 'ON_ORDER') {
                                        menuOptions.push({ 
                                            label: 'Finalizar', 
                                            onClick: async () => {
                                                await postAPI({ url: `/bid/${row.id}/finish` })
                                                refetchBids()
                                                }
                                        })
                                    }
                                    
                                    return (
                                        <ButtonGroup>
                                            <Button 
                                                variant="outlined"
                                                onClick={() => 
                                                    window.open(`https://api.whatsapp.com/send?phone=${row.whatsapp}&text=${messageText}`, '_blank')
                                                }
                                            >
                                                <WhatsAppIcon />
                                            </Button>
                                            <Button 
                                                variant="outlined"
                                                onClick={() => 
                                                    window.open(`https://t.me/${row.telegram.replace('@', '')}?text=${messageText}`, '_blank')
                                                }
                                            >
                                                <TelegramIcon />
                                            </Button>
                                            <Menu
                                                options={menuOptions}
                                            >
                                                <MoreHorizIcon />
                                            </Menu>
                                        </ButtonGroup>
                                    )
                                }
                            },
                        ]}
                        rows={bids?.data?.map((item: any) => ({
                            id: item.id,
                            user: item.user.name,
                            created_at: item.created_at,
                            company: COMPANY_OPTIONS.find(cia => cia.value === item.company)?.label,
                            amount: item.amount,
                            used_miles: item?.orders
                                ?.filter((item: {confirmation: string}) => ['PENDING', 'CONFIRMED'].includes(item.confirmation))
                                ?.reduce((prev: number, curr: {miles: number}) => currency(prev).add(curr.miles).value, 0),
                            used_pax: item?.orders
                                ?.filter((item: {confirmation: string}) => ['PENDING', 'CONFIRMED'].includes(item.confirmation))
                                ?.reduce((prev: number, curr: {pax: number}) => currency(prev).add(curr.pax).value, 0),
                            price_per_k: item.price_per_k,
                            pax: item.pax ? Number(item.pax) : null,
                            status: item.status,
                            whatsapp: item.user.whatsapp,
                            telegram: item.user.telegram
                        })) || []}
                    />
                    </Paper>
                </Grid></Fragment>)}
            </Grid>
        </Layout>
    )
}